import { DEFAULT_PROPERTY_DETAILS_TAB } from '@/constants';
import { DashboardRouteParams } from '@/types';
import { useParams } from 'react-router-dom';

/**
 * Custom hook to determine the active property details tab based on the route parameters.
 * Returns the tab specified in the URL or the default tab if none is specified.
 */
export const useActivePropertyDetailsTab = () => {
  const { propertyDetailsTab } = useParams<DashboardRouteParams>();
  return propertyDetailsTab || DEFAULT_PROPERTY_DETAILS_TAB;
};
